import { Badge } from '@uhg-abyss/web/ui/Badge';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

/**
 * ModeBadge
 *
 * displays the mode of the action path.
 *
 * @param actionPath
 * @param mode
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export function ModeBadge({ actionPath = {}, mode = '' }) {
  if (mode === 'automatic' || actionPath?.manualAssociation === false) {
    return (
      <Badge
        icon={<IconSymbol icon="autorenew" size={16} style={{ color: 'inherit' }} variant="outlined" />}
        outline
        variant="success"
      >
        Automatic
      </Badge>
    );
  }

  if (mode === 'manual' || actionPath?.manualAssociation === true) {
    return (
      <Badge
        icon={<IconSymbol icon="back_hand" size={16} style={{ color: 'inherit' }} variant="outlined" />}
        outline
        variant="warning"
      >
        Manual
      </Badge>
    );
  }

  return null;
}
